<template>
    <section class="content">
        <app-menu v-if="isLoggedIn"></app-menu>
        <div class="container-fluid">
            <div class="block-header">
                <h2>Dashboard</h2>
            </div>
        </div>
    </section>
</template>
<script>
    import Vue from 'vue';
    import FrontMenu from '@/components/partials/FrontMenu';
    import SessioMixin from '../mixins/sessionmixin';
    Vue.component('app-menu', FrontMenu);
    export default {
        name: 'FrontHome',
        mixins: [SessioMixin],
        data: () => ({
                isLoggedIn: false
            }),
        mounted: function () {
            this.$router.push("/login");
            if (localStorage.getItem("menu_small") == '1') {
                this.menuSmall();
            } else {
                this.menuBig();
            }
            //Textare auto growth
            //autosize($('textarea.auto-growth'));


        },
        beforeMount: function () {
            var self = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                this.isLoggedIn = true;
            } else {
                self.$router.push("/login");
            }
        }, methods: {
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/FrontHome.vue